import { createSelector } from '@reduxjs/toolkit';

import type { FilesFormatSchemaWithId } from '@iconik-io/iconik-api/src/services/files';

import { createEntitiesIndexSelector } from '../../entities_index/selectors';
import type { BaseAppState } from '../../types';

export const selectFormatsByAssetId = createEntitiesIndexSelector(
  'formats',
  'asset_id',
);

const getVersionId = (
  _state: BaseAppState,
  _assetId: string,
  versionId: string | undefined,
) => versionId;

export const selectAssetFormats = createSelector(
  [selectFormatsByAssetId, getVersionId],
  (formats, versionId) =>
    formats.filter((format) => {
      let result = format.status !== 'DELETED';
      if (versionId) {
        result &&= format.version_id === versionId;
      }

      return result;
    }),
);

export const selectAssetOriginalFormats = createSelector(
  [selectAssetFormats],
  (formats) =>
    formats.filter((format) => format.name?.toUpperCase() === 'ORIGINAL'),
);

export const selectAssetOriginalFormat = createSelector(
  [selectAssetOriginalFormats],
  (formats): FilesFormatSchemaWithId | undefined => formats[0],
);

export const selectAssetOriginalFormatFirstMetadata = createSelector(
  [selectAssetOriginalFormat],
  (format) => format?.metadata?.[0],
);

export const selectOriginalFormatsByVersionIdMap = createSelector(
  [selectAssetOriginalFormats],
  (formats) => {
    const originalFormatIds = new Set(formats.map((format) => format.id));

    const result: Record<string, FilesFormatSchemaWithId> = {};
    for (const format of formats) {
      if (format.version_id && originalFormatIds.has(format.id)) {
        result[format.version_id] = format;
      }
    }
    return result;
  },
);
